import React, { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CookiesKeys, URLs } from '../../Constants/Consts'
import { fetchApi } from '../../Helpers/Functions'
import { RootState } from '../../store/store'
import Cookies from "js-cookie";
import { addTechnology } from '../../store/Technology'

export default function storeRootCauses() {

    const [isloading, setIsloading] = React.useState(false)
    const dispatch = useDispatch()
    const SelectedUser = useSelector(
        (state: RootState) => state.SelectedUser.SelectedUser
    );
    const { downloadTriggered: { technology: triggered } } = useSelector(
        (state: RootState) => state.Utilities
    );
    const calledOnceRef = useRef(false)
    const currentToken = Cookies.get(CookiesKeys.jwt)
    React.useEffect(() => {
        (async () => {
            try {
                if (navigator.onLine && SelectedUser.jwt && currentToken && (!calledOnceRef.current || triggered)) {
                    calledOnceRef.current = true
                    setIsloading(true)
                    const technology = await fetchApi(
                        URLs.getTechnology())
                        .then(res => res.json())
                    // update store
                    dispatch(addTechnology(technology))
                    setIsloading(false)
                }
            } catch (error) {
                console.error("error from download tecnology", error);
            }
        })()
    }, [SelectedUser.jwt, triggered])
    return { isloading }
}
